import { createContext } from 'react';

export const MasterPageContext = createContext(null);
